import { render, staticRenderFns } from "./frontFooter503.vue?vue&type=template&id=40420670&scoped=true&"
import script from "./frontFooter503.vue?vue&type=script&lang=js&"
export * from "./frontFooter503.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40420670",
  null
  
)

export default component.exports